import React, { useEffect, useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

const CelebrationComponent = ({explosation, setExplosation}) => {
//   const [isExploding, setExplosation] = useState(false);

  const handleCelebrate = () => {
    setTimeout(() => {
        setExplosation(false);
    }, 5000);
  };

  useEffect(()=>{
    handleCelebrate();
  }, [explosation])

  return (
    <div className='fixed z-50 left-[50%] top-[50%]'>   
      {explosation && (
        <ConfettiExplosion
          force={0.7}
          duration={5000}
          particleCount={500}
          width={2680}
          height={1440}
          zIndex={30}
        />
      )}
    </div>
  );
};

export default CelebrationComponent;
